import React, { useState, useEffect, useContext } from "react";
import "./Login.css";
import { faEye, faEyeSlash, faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Blue_Round_Btn from "../common-components/common-btn/blue_round_btn/Blue_Round_Btn";
import { useLocation, useNavigate } from "react-router-dom";
import PasswordChecklist from "react-password-checklist";
import Success_Modal from "../common-components/common-modals/success_modal/Success_Modal";
import { Context } from "../../utils/context";
import { useDispatch } from "react-redux";
import { userSignUp, UserLogin } from "../../features/auth/authSlice";
import { RegxExpression } from "../../utils/common";
import Cookies from "js-cookie";

// NEW: reusable popup + the existing policy pages
import Policy_Modal from "../common-components/policy_modal/Policy_Modal";
import Terms_Conditions from "../terms_conditions/Terms_Conditions";
import Privacy_Policy from "../privacy_policy/Privacy_Policy";

const Login = (props) => {
  const { setIsLoggedIn } = useContext(Context);
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [successText, setSuccessText] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);
  const [errorText, setErrorText] = useState(null);

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");

  
  const [policyModal, setPolicyModal] = useState(null);

  
  const openPolicy = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    setPolicyModal(type);
  };

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    getValues,
    setError,
    formState: { errors },
    reset,
  } = useForm();

  const [showSignUp, setShowSignUp] = useState(false);

  const location = useLocation();
  const previousPath = sessionStorage.getItem("previousPath");
  console.log(previousPath, "previousPath previousPath");

  const onLoginSubmit = async (data) => {
    try {
      const sendData = {
        email: data.email,
        password: data.password,
      };

      const res = await dispatch(UserLogin(sendData));

      if (typeof res.payload === "string" && res.payload.startsWith("eyJ")) {
        setIsLoggedIn(true);
        setShowModal(true);
        setSuccessText("Login Successful!");
        setTimeout(() => {
          setShowModal(false);
          navigate("/");
        }, 2000);
      } else {
        if (res.payload?.errors?.email) {
          setError("email", {
            type: "server",
            message: res.payload.errors.email,
          });
        }
        if (res.payload?.errors?.password) {
          setError("password", {
            type: "server",
            message: res.payload.errors.password,
          });
        }
        if (!res.payload?.errors?.email && !res.payload?.errors?.password) {
          setErrorText("Login failed");
        }
      }
    } catch (error) {
      setErrorText(error.message || "An error occurred during login");
    }
  };

  const onSignUpSubmit = async (data) => {
    try {
      const sendData = {
        name: data?.name,
        contact_no: data?.contact_no,
        email: data?.email,
        password: data?.password,
        refer_code: data?.refer_code || "",
      };

      const res = await dispatch(userSignUp(sendData));

      if (typeof res.payload === "string") {
        // success (token)
        setShowModal(true);
        setSuccessText("Account Created Successfully !");
        setTimeout(() => {
          setShowModal(false);
          console.log(Cookies.get("current_url"), "current_url current_url");

          if (Cookies.get("current_url")) {
            const url = Cookies.get("current_url");
            Cookies.remove("current_url");
            navigate(url);
          } else {
            navigate("/");
          }
        }, 2000);
      } else if (res.payload?.errors) {
        if (res.payload.errors.email) {
          setError("email", {
            type: "server",
            message: res.payload.errors.email,
          });
        }
        if (res.payload.errors.contact_no) {
          setError("contact_no", {
            type: "server",
            message: res.payload.errors.contact_no,
          });
        }
        if (res.payload.errors.refer_code) {
          setError("refer_code", {
            type: "server",
            message: res.payload.errors.refer_code,
          });
        }
      }
    } catch (error) {
      setErrorText(error.message || "An error occurred during signup");
    }
  };

  // Scroll to top on first load and when switching Login <-> Signup
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [showSignUp]);

  return (
    <section className="Login">
      <div className="container-fluid">
        <div className="content_div">
          <div className="row justify-content-end">
            <div className="col-lg-5 my-auto">
              <div className="all_form_holder">
                <div className="goto_home_div" onClick={() => navigate("/")}>
                  <FontAwesomeIcon
                    icon={faHome}
                    className="home_icon"
                    alt="Home"
                  />
                </div>

                {!showSignUp && (
                  <div className="common_form_div">
                    <p className="title_text">Welcome To Bapat Optics</p>
                    <p className="subtitle_text">
                      Welcome back please enter your details
                    </p>

                    <div className="login_div">
                      <div className="login_form_div">
                        <Form onSubmit={handleSubmit(onLoginSubmit)}>
                          <Form.Group className="input_group">
                            <Form.Label>Email or Contact Number</Form.Label>
                            <Form.Control
                              type="text"
                              name="email"
                              placeholder="Enter Email or Contact Number"
                              {...register("email", {
                                required: "Email or Contact Number is required",
                              })}
                            />
                            {errors?.email && (
                              <sup className="text-danger">
                                {errors?.email?.message}
                              </sup>
                            )}
                          </Form.Group>

                          <Form.Group className="input_group">
                            <Form.Label>Password</Form.Label>
                            <div className="password_holder">
                              <Form.Control
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter Password"
                                name="password"
                                {...register("password", {
                                  required: "Password is required",
                                })}
                              />
                              <div className="eye-icc">
                                <FontAwesomeIcon
                                  icon={iconOne}
                                  className="icon"
                                  onClick={() =>
                                    togglePasswordVisibility("password")
                                  }
                                  aria-label="Toggle password visibility"
                                />
                              </div>
                            </div>
                            {errors?.password && (
                              <sup className="text-danger">
                                {errors?.password?.message}
                              </sup>
                            )}
                            <div className="form_footer">
                              <div>
                                <Form.Check
                                  type="checkbox"
                                  label="Remember my password"
                                  id="remember-password"
                                />
                              </div>
                              <p
                                className="link_text"
                                onClick={() => navigate("/reset-password")}
                              >
                                Forgot Password?
                              </p>
                            </div>
                          </Form.Group>

                          <div className="btn_holder">
                            <Blue_Round_Btn btnText="Login" type="submit" />
                          </div>

                          <p className="dark_text">
                            Don't have an account?{" "}
                            <span
                              className="link_text"
                              onClick={() => {
                                setShowSignUp(true);
                                setErrorText(null);
                                reset();
                              }}
                            >
                              Create Account
                            </span>
                          </p>
                        </Form>
                      </div>
                    </div>
                  </div>
                )}

                {showSignUp && (
                  <div className="common_form_div">
                    <p className="title_text">Sign Up</p>
                    <p className="subtitle_text">Create your account</p>

                    <div className="login_div">
                      <div className="login_form_div">
                        <Form onSubmit={handleSubmit(onSignUpSubmit)}>
                          <Form.Group className="gray_input_group input_group">
                            <Form.Label>Full Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Full Name"
                              {...register("name", {
                                required: "Full Name is required",
                                pattern: {
                                  value: RegxExpression.name,
                                  message:
                                    "Name can only contain letters and spaces",
                                },
                              })}
                            />
                            {errors?.name && (
                              <sup className="text-danger">
                                {errors?.name?.message}
                              </sup>
                            )}
                          </Form.Group>

                          <Form.Group className="gray_input_group input_group">
                            <Form.Label>Mobile Number</Form.Label>
                            <Form.Control
                              type="text"
                              maxLength={10}
                              placeholder="Enter mobile number"
                              {...register("contact_no", {
                                required: "Mobile Number is required",
                                pattern: {
                                  value: /^[0-9]{10}$/,
                                  message: "Enter valid 10-digit mobile number",
                                },
                              })}
                              onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                  e.preventDefault(); // blocks non-numeric input
                                }
                              }}
                            />
                            {errors?.contact_no && (
                              <sup className="text-danger">
                                {errors?.contact_no?.message}
                              </sup>
                            )}
                          </Form.Group>

                          <Form.Group className="gray_input_group input_group">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                              type="email"
                              placeholder="Enter Email"
                              {...register("email", {
                                required: "Email is required",
                                pattern: {
                                  value: RegxExpression.email,
                                  message: "Invalid email address",
                                },
                              })}
                            />
                            {errors?.email && (
                              <sup className="text-danger">
                                {errors?.email?.message}
                              </sup>
                            )}
                          </Form.Group>

                          <Form.Group className="gray_input_group input_group">
                            <Form.Label>Referral Code (Optional)</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Referral Code"
                              {...register("refer_code")}
                            />
                            {errors?.refer_code && (
                              <sup className="text-danger">
                                {errors?.refer_code?.message}
                              </sup>
                            )}
                          </Form.Group>

                          <Form.Group className="gray_input_group input_group">
                            <Form.Label className="label_text">
                              New Password
                            </Form.Label>
                            <div className="password_holder">
                              <Form.Control
                                type={showPassword ? "text" : "password"}
                                name="password"
                                placeholder="Enter New Password"
                                {...register("password", {
                                  required: "Password is required",
                                  minLength: {
                                    value: 8,
                                    message:
                                      "Password must be at least 8 characters long",
                                  },
                                  pattern: {
                                    value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                                    message:
                                      "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                                  },
                                })}
                                onChange={(e) => setPassword(e.target.value)}
                              />
                              <div className="eye-icc">
                                <FontAwesomeIcon
                                  icon={iconOne}
                                  className="icon"
                                  onClick={() =>
                                    togglePasswordVisibility("password")
                                  }
                                  aria-label="Toggle password visibility"
                                />
                              </div>
                            </div>
                            {errors?.password && (
                              <sup className="text-danger">
                                {errors?.password?.message}
                              </sup>
                            )}
                          </Form.Group>

                          <Form.Group className="gray_input_group input_group">
                            <Form.Label className="label_text">
                              Confirm Password
                            </Form.Label>
                            <div className="password_holder">
                              <Form.Control
                                type={showPasswordOne ? "text" : "password"}
                                name="re_password"
                                placeholder="Enter Confirm Password"
                                {...register("re_password", {
                                  required: "Confirm Password is required",
                                  validate: (value) =>
                                    value === getValues("password") ||
                                    "Passwords do not match",
                                })}
                                onChange={(e) =>
                                  setPasswordAgain(e.target.value)
                                }
                              />
                              <div className="eye-icc">
                                <FontAwesomeIcon
                                  icon={iconTwo}
                                  className="icon"
                                  onClick={() =>
                                    togglePasswordVisibility("reenterPassword")
                                  }
                                  aria-label="Toggle confirm password visibility"
                                />
                              </div>
                            </div>
                            {errors?.re_password && (
                              <sup className="text-danger">
                                {errors?.re_password?.message}
                              </sup>
                            )}
                          </Form.Group>

                          {password && (
                            <div className="password_check_list">
                              <PasswordChecklist
                                rules={[
                                  "minLength",
                                  "specialChar",
                                  "number",
                                  "capital",
                                  "match",
                                ]}
                                minLength={8}
                                value={password}
                                valueAgain={passwordAgain}
                                onChange={(isValid) => {}}
                                style={{
                                  fontSize: "10px",
                                  padding: "4px",
                                  margin: "0",
                                }}
                              />
                            </div>
                          )}

                          {errorText && (
                            <div className="text-danger text-center">
                              {errorText}
                            </div>
                          )}

                          <div className="btn_holder">
                            <Blue_Round_Btn btnText="Sign Up" type="submit" />
                          </div>

                          {/* NEW: Terms & Privacy consent, just below Sign Up */}
                          <div className="terms_consent">
                            <Form.Check
                              type="checkbox"
                              id="signup_terms_checkbox"
                              {...register("terms", {
                                required:
                                  "Please accept the Terms & Conditions to continue.",
                              })}
                              label={
                                <>
                                  I agree to the{" "}
                                  <a
                                    href="/terms-conditions"
                                    onClick={(e) => openPolicy(e, "terms")}
                                  >
                                    Terms &amp; Conditions
                                  </a>{" "}
                                  and{" "}
                                  <a
                                    href="/privacy"
                                    onClick={(e) => openPolicy(e, "privacy")}
                                  >
                                    Privacy Policy
                                  </a>
                                </>
                              }
                            />
                            {errors?.terms && (
                              <p className="terms_error">
                                {errors.terms.message}
                              </p>
                            )}
                          </div>

                          <p className="dark_text">
                            Already have an account?{" "}
                            <span
                              className="link_text"
                              onClick={() => {
                                setShowSignUp(false);
                                setErrorText(null);
                                reset();
                              }}
                            >
                              Log In
                            </span>
                          </p>
                        </Form>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="login_img_holder">
                <img
                  src="/assets/images/login/rightimg.png"
                  className="right_img"
                  alt="Login"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Success_Modal
        show={showModal}
        successText={successText}
        onHide={() => setShowModal(false)}
      />

      {/* NEW: Terms & Privacy popups */}
      <Policy_Modal
        show={policyModal === "terms"}
        onHide={() => setPolicyModal(null)}
        title="Terms & Conditions"
      >
        <Terms_Conditions />
      </Policy_Modal>

      <Policy_Modal
        show={policyModal === "privacy"}
        onHide={() => setPolicyModal(null)}
        title="Privacy Policy"
      >
        <Privacy_Policy />
      </Policy_Modal>
    </section>
  );
};

export default Login;